import Facebook from "@components/Icons/facebook.svg";
import Twitter from "@components/Icons/twitter.svg";
import Linkedin from "@components/Icons/linkedin.svg";
import Instagram from "@components/Icons/instagram.svg";
import PersonalWebsite from "@components/Icons/personal-website.svg";
import CompanyWebsite from "@components/Icons/company-website.svg";

const SocialList = ({data}) =>{

	const {
		social: {
			company_website: companyWebsite = '',
			personal_website: personalWebsite = '',
			facebook = '',
			twitter = '',
			linkedin = '',
			instagram = ''
		}
	} = data;

	const hasSocial = companyWebsite || personalWebsite || facebook || twitter || linkedin || instagram;

	// Prepare list of social links.
	const list = [
		{
			name:'Facebook',
			value:facebook,
			icon:Facebook
		},
		{
			name:'Twitter',
			value:twitter,
			icon:Twitter
		},
		{
			name:'Linkedin',
			value:linkedin,
			icon:Linkedin
		},
		{
			name:'Instagram',
			value:instagram,
			icon:Instagram
		},
		{
			name:'Company Website',
			value:companyWebsite,
			icon:CompanyWebsite
		},
		{
			name:'Personal Website',
			value:personalWebsite,
			icon:PersonalWebsite
		},
	];
	const linkTarget = '_blank';

	return (
		<>{
			hasSocial && <ul className="cfs-speaker-details-social-list">
			{list.map((social, index)=>{
				return social.value && <li key={index}><a className="cfs-speaker-details-social-list__link" href={social.value} title={social.name} target={linkTarget}><img className="cfs-talk-ui-icon" src={social.icon} alt={social.name} /></a>
				</li>
			})}
		</ul>
		}</>
	)
}
export default SocialList;
